import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_a7kevhkvzk: FaireBrandEntity = {
  token: "b_a7kevhkvzk",
  type: "brand",
  name: "Ecologie",
  avatarUrl:
    "https://cdn.faire.com/fastly/9b27083d0e1c0c1354806b1a70c317f0852d5f704e1846b9ab25c7747e1e1634.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/6f1d5a239dff4d5e2163dd2e84a6cff23970076077433d761831575a4a402232.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/9b27083d0e1c0c1354806b1a70c317f0852d5f704e1846b9ab25c7747e1e1634.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/6f1d5a239dff4d5e2163dd2e84a6cff23970076077433d761831575a4a402232.jpeg",
  location: "Auburn, WA, USA",
  minimumOrderDollars: 200,
  rating: 4.8,
  reviewCount: 26,
  isInsider: false,
  description:
    "Ecologie by Danica is the natural result of our deep passion for environmental sustainability and creative design, bringing a little thoughtful beauty to your world. Authentically made in Sweden, our sponge cloths are equal parts stylish and effective. Turn one-time use paper towels and plastic into a thing of the past with Ecologie. Our beeswax wraps and bags offer an array of colors and patterns for reusable storage. Explore our collection and discover why sustainable living has never been so vibrant – or so fun!\n\nA percentage of the profit on the sale of our product lines goes to Education without Borders (EwB), a Canadian non-profit organization created in 2002. Education without Borders provides educational opportunities for disadvantaged and at-risk children through initiatives in South Africa and Canada, including after-school support programs in Math, English, Science, school leadership and youth mentorship. Our chairman Rodney Benson is the co-founder.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:45:15.199Z",
    importedBy: "entity-db-cli",
  },
};
